export default class Chat {
    constructor() {
        this.form = document.getElementById('chat-form');
        this.feed = document.getElementById('chat-feed');
        if (!this.form) return;

        // UI & Inputs
        this.replyPreview = document.getElementById('reply-preview');
        this.replyText = document.getElementById('reply-text');
        this.cancelReplyBtn = document.getElementById('cancel-reply');
        
        this.titleInput = document.getElementById('chat-backend-title');
        this.parentInput = document.getElementById('field_parent_id');
        this.parentNameInput = document.getElementById('field_parent_name');
        this.parentPreviewInput = document.getElementById('field_parent_preview');
        this.chatTypeInput = document.getElementById('field_chat_type');
        this.messageInput = document.getElementById('field_message_text');
        this.systemToggle = document.getElementById('system-toggle');

        // Media / Meme Modal Elements
        this.mediaModalEl = document.getElementById('mediaModal');
        this.mediaModal = this.mediaModalEl ? new bootstrap.Modal(this.mediaModalEl) : null;
        this.memeBtn = document.getElementById('meme-btn');
        this.mediaUrlInput = document.getElementById('media-url-input');
        this.hiddenMediaField = document.getElementById('field_media_url');
        this.mediaPreviewContainer = document.getElementById('media-preview-container');
        this.mediaPreviewImg = document.getElementById('media-preview-img');
        this.saveMediaBtn = document.getElementById('save-media-btn');
        this.clearMediaBtn = document.getElementById('clear-media');

        // New Media Preview Bar (Main UI)
        this.mediaAttachedPreview = document.getElementById('media-attached-preview');
        this.attachedUrlText = document.getElementById('attached-url-text');
        this.removeMediaBtn = document.getElementById('remove-media-preview');

        // Context from Data Attributes
        this.myScreenName = this.form.dataset.screenName || 'Member';
        this.myMemberId = this.form.dataset.memberId || '0';
        this.leagueId = this.form.dataset.leagueId || '0';

        this.init();
    }

    init() {
        this.updateBackendTitle();
        this.bindEvents();
    }

    bindEvents() {
        if (this.feed) {
            this.feed.addEventListener('click', (e) => {
                if (e.target.classList.contains('btn-reply')) {
                    this.enterReplyMode(e.target.dataset);
                }
                const reactBtn = e.target.closest('.btn-react');
                if (reactBtn) this.handleReaction(reactBtn);
            });
        }

        if (this.cancelReplyBtn) {
            this.cancelReplyBtn.addEventListener('click', () => this.exitReplyMode());
        }

        if (this.systemToggle) {
            this.systemToggle.addEventListener('change', (e) => {
                if (this.chatTypeInput) {
                    this.chatTypeInput.value = e.target.checked ? 'system' : 'text';
                }
                this.updateBackendTitle();
            });
        }

        // Media Modal Events
        if (this.memeBtn && this.mediaModal) {
            this.memeBtn.addEventListener('click', () => this.mediaModal.show());
        }

        if (this.mediaUrlInput) {
            this.mediaUrlInput.addEventListener('input', (e) => {
                const url = e.target.value.trim();
                if (url && (url.match(/\.(jpeg|jpg|gif|png|webp)$/i) || url.includes('giphy.com'))) {
                    this.mediaPreviewImg.src = url;
                    this.mediaPreviewContainer.classList.remove('d-none');
                } else {
                    this.mediaPreviewContainer.classList.add('d-none');
                }
            });
        }

        if (this.saveMediaBtn) {
            this.saveMediaBtn.addEventListener('click', () => {
                const url = this.mediaUrlInput.value.trim();
                if (url) {
                    this.hiddenMediaField.value = url;
                    this.memeBtn.classList.add('btn-info', 'text-black');
                    this.memeBtn.classList.remove('btn-outline-light');
                    
                    // Show preview bar on main UI
                    if (this.attachedUrlText) this.attachedUrlText.innerText = url;
                    if (this.mediaAttachedPreview) this.mediaAttachedPreview.classList.remove('d-none');
                }
                this.mediaModal.hide();
            });
        }

        if (this.clearMediaBtn) {
            this.clearMediaBtn.addEventListener('click', () => this.resetMedia());
        }

        if (this.removeMediaBtn) {
            this.removeMediaBtn.addEventListener('click', () => this.resetMedia());
        }

        this.form.addEventListener('submit', (e) => {
            e.preventDefault();
            this.submitRoast();
        });
    }

    resetMedia() {
        if (this.hiddenMediaField) this.hiddenMediaField.value = '';
        if (this.mediaUrlInput) this.mediaUrlInput.value = '';
        if (this.mediaPreviewContainer) this.mediaPreviewContainer.classList.add('d-none');
        if (this.mediaAttachedPreview) this.mediaAttachedPreview.classList.add('d-none');
        
        if (this.memeBtn) {
            this.memeBtn.classList.remove('btn-info', 'text-black');
            this.memeBtn.classList.add('btn-outline-light');
        }
    }

    updateBackendTitle() {
        if (!this.titleInput) return;
        
        const type = this.chatTypeInput?.value || 'text';
        const parent = this.parentInput?.value || '0';
        const now = new Date().toLocaleTimeString([], { hour12: true });
        
        this.titleInput.value = `${this.myScreenName} posted in League ID: ${this.leagueId} | Type: ${type} | parentID: ${parent} | authorID: ${this.myMemberId} | @ ${now}`;
    }

    enterReplyMode(data) {
        if (this.parentInput) this.parentInput.value = data.id;
        if (this.parentNameInput) this.parentNameInput.value = data.author;
        if (this.parentPreviewInput) this.parentPreviewInput.value = data.text.substring(0, 50);

        if (this.replyText) this.replyText.innerText = `Replying to ${data.author}...`;
        if (this.replyPreview) this.replyPreview.classList.remove('d-none');
        
        if (this.messageInput) this.messageInput.focus();
        
        this.updateBackendTitle();
        this.form.scrollIntoView({ behavior: 'smooth' });
    }

    exitReplyMode() {
        if (this.parentInput) this.parentInput.value = '0';
        if (this.parentNameInput) this.parentNameInput.value = '';
        if (this.parentPreviewInput) this.parentPreviewInput.value = '';
        
        if (this.replyPreview) this.replyPreview.classList.add('d-none');
        
        this.updateBackendTitle();
    }

    async submitRoast() {
        this.updateBackendTitle();
        const formData = new FormData(this.form);

        try {
            const response = await fetch(this.form.action, {
                method: 'POST',
                body: formData,
                headers: { 'X-Requested-With': 'XMLHttpRequest' }
            });

            const result = await response.json();
            if (result.success) {
                if (this.messageInput) this.messageInput.value = '';
                this.resetMedia();
                this.exitReplyMode();
                location.reload(); 
            } else {
                console.error('EE Errors:', result.errors);
                alert('Error submitting roast.');
            }
        } catch (error) {
            console.error('Submission error:', error);
        }
    }

    async handleReaction(buttonElement) {
        const parentContainer = buttonElement.closest('.reaction-group');
        const entryId = parentContainer.dataset.entryId;
        const reactionType = buttonElement.dataset.type;

        const originalContent = buttonElement.innerHTML; 

        buttonElement.innerHTML = `<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>`;
        buttonElement.disabled = true;

        const reactionData = new FormData();
        reactionData.append('entry_id', entryId);
        reactionData.append('type', reactionType);
        
        if (window.EE?.CSRF_TOKEN) {
            reactionData.append('csrf_token', window.EE.CSRF_TOKEN);
        }

        try {
            const fetchResponse = await fetch('/api/chat-process-reactions', {
                method: 'POST',
                body: reactionData
            });

            const rawServerOutput = await fetchResponse.text();
            
            const payloadStart = rawServerOutput.indexOf('ey');
            if (payloadStart === -1) throw new Error('Invalid server response');
            
            const cleanBase64 = rawServerOutput.substring(payloadStart).trim();
            const result = JSON.parse(atob(cleanBase64));

            if (result.status === 'success') {
                this.toggleReactionUI(buttonElement, result.active);
                const emoji = reactionType === 'likes' ? '🔥' : (reactionType === 'laughing' ? '🤡' : '🍿');
                buttonElement.innerHTML = `${emoji} <span class="count">${result.new_count}</span>`;
            }

        } catch (error) {
            console.error("Reaction failed:", error);
            buttonElement.innerHTML = originalContent;
        } finally {
            buttonElement.disabled = false;
        }
    }

    toggleReactionUI(button, isActive) {
        if (isActive) {
            button.classList.add('active');
            button.classList.remove('btn-dark');
        } else {
            button.classList.remove('active');
            button.classList.add('btn-dark');
        }
    }
}